<template>
  <b-form-checkbox
    v-model="checkboxValue"
    :class="{ checkboxStyle, 'checkbox--disable': isDisable }"
    :disabled="isDisable"
    :value="true"
    :unchecked-value="false"
    @change="changeMethod"
  >
    <span
      :style="textStyle"
      :class="[classForActiveCheckboxColor, textClass]"
      >{{ title }}</span
    >
  </b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue"

export default {
  name: "AtomCheckbox",
  components: {
    BFormCheckbox,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: "primary",
    },
    textClass: {
      type: String,
      required: false,
      default: "",
    },
    textStyle: {
      type: String,
      required: false,
      default: "",
    },
    idx: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    isColorTextOnActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    checkboxValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    checkboxStyle() {
      if (this.color === "secondary") {
        return "custom-control-secondary"
      } else if (this.color === "success") {
        return "custom-control-success"
      } else if (this.color === "danger") {
        return "custom-control-danger"
      } else if (this.color === "warning") {
        return "custom-control-warning"
      } else if (this.color === "info") {
        return "custom-control-info"
      } else if (this.color === "dark") {
        return "custom-control-dark"
      } else {
        return "custom-control-primary"
      }
    },
    classForActiveCheckboxColor() {
      return this.isColorTextOnActive && this.checkboxValue
        ? "text--active"
        : ""
    },
  },
  methods: {
    changeMethod() {
      this.$emit("checkboxValueIndex", this.idx)
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox--disable {
  pointer-events: none;
}

.text--active {
  color: #7367f0;
}
</style>
